import { DailyGoals } from "./DailyGoals";
import { ShowEncouragementStatusMessage } from "./ShowEncouragementStatusMessage";

export function ToggleCheckedGoal(dailyGoals: DailyGoals, goalName: string) {
    const { checkedGoals } = dailyGoals.state;
    const isAlreadyChecked = checkedGoals.includes(goalName);

    dailyGoals.setState({
        checkedGoals: isAlreadyChecked
            ? ExcludeFrom(checkedGoals, goalName)
            : IncludeWith(checkedGoals, goalName),
    });

    if (!isAlreadyChecked) {
        ShowEncouragementStatusMessage();
    }
}

const ExcludeFrom = (array: string[], toExclude: string) =>
    array.filter((elem) => elem !== toExclude);

const IncludeWith = (array: string[], toInclude: string) => [
    ...array,
    toInclude,
];
